export const FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST =
  "FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST";
export const FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS =
  "FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS";
export const FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE =
  "FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE";

export const FETCH_ORDER_ENTRY_VENDORS_REQUEST =
  "FETCH_ORDER_ENTRY_VENDORS_REQUEST";
export const FETCH_ORDER_ENTRY_VENDORS_SUCCESS =
  "FETCH_ORDER_ENTRY_VENDORS_SUCCESS";
export const FETCH_ORDER_ENTRY_VENDORS_FAILURE =
  "FETCH_ORDER_ENTRY_VENDORS_FAILURE";

export const ADD_UPDATE_ORDER_ENTRY_CUSTOMER_REQUEST =
  "ORDER_ENTRY_ADD_UPDATE_CUSTOMER_REQUEST";
export const ADD_UPDATE_ORDER_ENTRY_CUSTOMER_SUCCESS =
  "ORDER_ENTRY_ADD_UPDATE_CUSTOMER_SUCCESS";
export const ADD_UPDATE_ORDER_ENTRY_CUSTOMER_FAILURE =
  "ORDER_ENTRY_ADD_UPDATE_CUSTOMER_FAILURE";

export const ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST =
  "ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST";
export const ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS =
  "ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS";
export const ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE =
  "ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE";
export const FETCH_CUSTOMER_REFERENCES_REQUEST =
  "FETCH_CUSTOMER_REFERENCES_REQUEST";
export const FETCH_CUSTOMER_REFERENCES_SUCCESS =
  "FETCH_CUSTOMER_REFERENCES_SUCCESS";
export const FETCH_CUSTOMER_REFERENCES_FAILURE =
  "FETCH_CUSTOMER_REFERENCES_FAILURE";
export const FETCH_LOZIER_DIMENSIONS_REQUEST =
  "FETCH_LOZIER_DIMENSIONS_REQUEST";
export const FETCH_LOZIER_DIMENSIONS_SUCCESS =
  "FETCH_LOZIER_DIMENSIONS_SUCCESS";
export const FETCH_LOZIER_DIMENSIONS_FAILURE =
  "FETCH_LOZIER_DIMENSIONS_FAILURE";

export const FETCH_VENDORSERVICETYPES_REQUEST =
  "FETCH_VENDORSERVICETYPES_REQUEST";
export const FETCH_VENDORSERVICETYPES_SUCCESS =
  "FETCH_VENDORSERVICETYPES_SUCCESS";
export const FETCH_VENDORSERVICETYPES_FAILURE =
  "FETCH_VENDORSERVICETYPES_FAILURE";

export const ADD_UPDATE_VENDORSERVICETYPES_REQUEST =
  "ADD_UPDATE_VENDORSERVICETYPES_REQUEST";
export const ADD_UPDATE_VENDORSERVICETYPES_SUCCESS =
  "ADD_UPDATE_VENDORSERVICETYPES_SUCCESS";
export const ADD_UPDATE_VENDORSERVICETYPES_FAILURE =
  "ADD_UPDATE_VENDORSERVICETYPES_FAILURE";
